import React from 'react';

const Titles = () => (
    <div id="titles">
        <h1 className="center-align">Stats Map</h1>
        <p className="center-align">Click on the map to place a marker and see local weather and country statistics.</p>
    </div>
);

export default Titles;